import {Tile} from "../components/Tile.tsx";
import {Box} from "@mui/joy";
import {ActionButton} from "../components/ActionButton.tsx";
import {useNavigate} from "@tanstack/react-router";
import {useTranslation} from "react-i18next";

export function SpawnWasteTile(props: { bundleId: string }) {
    const navigate = useNavigate();
    const {t} = useTranslation();

    return <Tile variant="soft" color="primary">
        <Box sx={{
            display: "flex",
            alignItems: "center", justifyContent: "center",
            minHeight: "6rem",
        }}>
            <ActionButton color="primary" size="lg" perform={() =>
                navigate({
                    to: "/waste-new",
                    params: {},
                    search: {bundleId: props.bundleId},
                })}>
                {t("newWaste")}
            </ActionButton>
        </Box>
    </Tile>
}